export default {
  domesticCountry: 'DE',
  defaultCurrency: '€',
  defaultCurrencyString: ' €',
};
